import { processContent, bindable, containerless, autoinject } from 'aurelia-framework';
import { inheritBindingContext } from '../../component-model/template-elements';
import { Combobox } from './combobox';

@processContent(inheritBindingContext(true))
@autoinject
export class ComboboxOption {
	@bindable model: any;
	@bindable active = false;
	@bindable index: number;
	@bindable select: (params: { model: any }) => void;
	@bindable changeFocus: (params: { index: any, element: Element }) => void;

	constructor(private element: Element, private combobox: Combobox) {
	}

	bind() {
		this.combobox.addOptionElement(this.index, this.element as HTMLElement);
	}

	onSelect() {
		this.select({ model: this.model });
	}

	onFocused() {
		this.active = true;
		this.changeFocus({ index: this.index, element: this.element });
	}
}
